
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class GlobalFunctional extends Vue {
  @Prop({ default: "light" }) theme!: string;
  @Prop({ default: [] }) data!: any;

  @Watch("data", { deep: true })
  dataChange(nval: any, oval: any) {
    if (!this.sourceData.length) {
      this.sourceData = JSON.parse(JSON.stringify(nval));
    } else {
      this.sourceData.forEach((item: any, index: number) => {
        const el = this.$refs[
          "global" + item.componentPageName
        ] as HTMLImageElement;
        if (!el) {
          return;
        }
        if (!item.active && nval[index].active) {
          el[0].classList.add("active-animation");
          el[0].classList.add("popup-animation");
        } else {
          el[0].className = "icon-container";
        }
      });
      this.sourceData = JSON.parse(JSON.stringify(nval));
    }
  }

  sourceData: any = [];

  getImage(item: any) {
    if (item.active) {
      return require(`@/views/ai-builder-component/assets/globalFunctional/${item.icon}-active.png`);
    } else {
      return require(`@/views/ai-builder-component/assets/globalFunctional/${item.icon}-default-${this.theme}.png`);
    }
  }

  setGlobal(item: any) {
    this.$emit("setGlobal", {
      componentPageName: item.componentPageName,
      active: item.active
    });
  }
}
